export const REQUEST_GET_ALL_STATUS = 'lead/REQUEST_GET_ALL_STATUS';
export const RECEIVED_GET_ALL_STATUS = 'lead/RECEIVED_GET_ALL_STATUS';
export const RECEIVED_ERROR = 'lead/RECEIVED_ERROR';
export const SET_FILTERD_OPTIONLIST = "lead/SET_FILTERD_OPTIONLIST";

export const RECEIVED_ALL_LEADS = 'lead/RECEIVED_ALL_LEADS';
export const REQUEST_ALL_LEADS = 'lead/REQUEST_ALL_LEADS';
export const RECEIVED_LEAD_SUCCESS_PREDICTION_DATA = 'lead/RECEIVED_GET_LEAD_SUCCESS_PREDICTION_DATA';

export const REQUEST_GET_PAGED_LEADS = 'lead/REQUEST_GET_PAGED_LEADS';
export const RECEIVED_PAGED_LEADS = 'lead/RECEIVED_PAGED_LEADS';
